// Кэширующий Service Worker вызывал «белый экран» у клиентов (см. generate-sw.js).
// Поэтому мы НЕ регистрируем SW, а наоборот — принудительно снимаем все старые
// регистрации и чистим кэши при загрузке приложения. Это страхует те браузеры,
// которым всё же удалось загрузить свежий код, но в которых остался залипший SW.
export function register() {
  unregister();
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    // Снимаем ВСЕ регистрации (и /service-worker.js, и /custom-service-worker.js)
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch((error) => console.error(error.message));
  }

  // Удаляем все кэши, оставшиеся от старого кэширующего SW
  if ('caches' in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch((error) => console.error(error.message));
  }
}
